// Module
var code = `	<amt-form-inline
		name='migration.GlobalMigrationForm'
		on-submit='start(model)'
		options='{supressPropertyTitles: true}'
	></amt-form-inline>

<table class="table">
    <tr>
        <th>Task ID</th>
        <th>Created</th>
        <th>From</th>
        <th>To</th>
        <th>Select batch</th>
        <th>Insert batch</th>
        <th>Actions</th>
    </tr>
    <tr ng-repeat-start="(task_id, task) in tasks">
        <td>{{task_id}}</td>
        <td>{{task.datetime_created}}</td>
        <td>{{task.date_from}}</td>
        <td>{{task.date_to}}</td>
        <td>{{task.request_batch}}</td>
        <td>{{task.insert_batch}}</td>
        <td>
            <button ng-click="stop_task(task_id)">Stop task</button>
	        <button ng-click="delete_task(task_id)">Delete task</button>
        </td>
    </tr>
    <tr ng-repeat-end ng-show="task.tables">
        <td colspan="7"  style="border: 0; padding: 2px;">
            <table class="table">
                <tr>
                    <th>Table</th>
                    <th>Temporary table</th>
                    <th>Total Count</th>
                    <th>Errors</th>
                    <th>Action</th>
                </tr>
                <tr ng-repeat-start="(table_name, table) in task.tables">
                    <td>{{table_name}}</td>
                    <td>{{table.temp_table}}</td>
                    <td>{{table.count}}</td>
                    <td>{{table.error}}</td>
                    <td>
                        <button ng-click="delete_temp_table(task_id, table_name)">Delete temp table</button>
                        <button ng-click="consume(task_id, table_name)">Consume</button>
                    </td>
                    <td>
                    </td>
                </tr>
                <tr ng-repeat-end>
                    <td colspan="5"  style="border: 0; padding: 2px;">
                    <table class="table" ng-if="table.subtasks">
                        <tr>
                            <th>Subtask ID</th>
                            <th>ES index</th>
                            <th>ES shard</th>
                            <th>ES node</th>
                            <th>Count</th>
                            <th>Migrated</th>
                            <th>Status</th>
                        </tr>
                        <tr ng-repeat="(subtask_id, subtask) in table.subtasks">
                            <td>{{subtask_id}}</td>
                            <td>{{subtask.index}}</td>
                            <td>{{subtask.shard}}</td>
                            <td>{{subtask.node}}</td>
                            <td>{{subtask.total_count}}</td>
                            <td>{{subtask.migrated_count}}</td>
                            <td>{{subtask.status}}<span ng-if="subtask.status == 'error'">: {{subtask.error_message}}</span></td>
                            <td><button ng-click="stop_subtask(task_id, subtask_id)">Stop subtask</button></td>
                        </tr>
                    </table>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</table>
`;
// Exports
module.exports = code;